import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Transition to a new state. If there is no state yet, the new state must be an initial state. If the existing state has `}<inlineCode parentName="p">{`transitions`}</inlineCode>{` set, there must be a direct transition to the new state. If `}<inlineCode parentName="p">{`transitions`}</inlineCode>{` is not set, no validation is performed. These validations can be turned off by setting the `}<inlineCode parentName="p">{`force`}</inlineCode>{` parameter to `}<inlineCode parentName="p">{`true`}</inlineCode>{`.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"transitionState"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`state`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/types#reference"
          }}>{`Reference`}</a>{` to a `}<a parentName="li" {...{
            "href": "/api/../api/projects/states#state"
          }}>{`State`}</a></li>
        <li parentName="ul"><inlineCode parentName="li">{`force`}</inlineCode>{` - Boolean - Optional - Defaults to `}<inlineCode parentName="li">{`false`}</inlineCode></li>
      </ul>
      <p parentName="section">{`This update action produces an `}<a parentName="p" {...{
          "href": "/api/../api/message-types#orderstatetransitionmessage"
        }}>{`OrderStateTransitionMessage`}</a>{`.`}</p>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      